import { HttpParams } from '@angular/common/http';

export default function toHttpParams(obj: any): HttpParams {
    return Object.getOwnPropertyNames(obj)
        .reduce((p, key) => p.set(key, obj[key]), new HttpParams());
}
